import React from "react";
import ScrollRevealText from "../Comman/ScrollRevealText";

export default function WhyChooseK() {
  return (
    <>
      <div className="tp-service-area  tp-btn-trigger">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-12 col-xl-12 ">
              <div className="tp-about-2-title-box tp-btn-trigger tp-btn-bounce mb-70 text-start text-xl-center">
                <ScrollRevealText text=" Why Kryptogram is the Ultimate NFT Investment" />
              </div>
            </div>
          </div>

          <div className="tp-service-right-wrap">
            <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div className="tp-service-item d-flex align-items-start mb-75 tp_fade_bottom">
                  <div className="icon-one">
                    <img
                      style={{ width: "160px" }}
                      src="assets/img/one/real_world_utility.png"
                      alt="land_ownership"
                    />
                  </div>
                  <div className="tp-service-content">
                    <h4 className="tp-service-title-sm order-0 text-yellow-new text-uppercase">
                      <a>Real-World Utility </a>
                    </h4>
                    <p>
                      Secure physical land in the USA with blockchain
                      transparency.
                    </p>
                  </div>
                </div>
                <div className="tp-service-item d-flex align-items-start mb-75 tp_fade_bottom">
                  <div className="icon-one">
                    <img
                      style={{ width: "160px" }}
                      src="assets/img/one/event_access.png"
                      alt="land_ownership"
                    />
                  </div>
                  <div className="tp-service-content">
                    <h4 className="tp-service-title-sm order-0 text-yellow-new text-uppercase">
                      <a>Event Access</a>
                    </h4>
                    <p>Guaranteed VIP entry to Tribe O Crypto Festival.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div className="tp-service-item d-flex align-items-start mb-75 tp_fade_bottom">
                  <div className="icon-one">
                    <img
                      style={{ width: "160px" }}
                      src="assets/img/one/tangible_ownership.png"
                      alt=""
                    />
                  </div>
                  <div className="tp-service-content">
                    <h4 className="tp-service-title-sm text-yellow-new text-uppercase">
                      <a> Tangible Ownership</a>
                    </h4>
                    <p>
                      NFTs linked directly to decentralized property
                      verification.
                    </p>
                  </div>
                </div>
                <div className="tp-service-item d-flex align-items-start mb-75 tp_fade_bottom">
                  <div className="icon-one">
                    <img
                      style={{ width: "230px" }}
                      src="assets/img/one/future_ready.png"
                      alt=""
                    />
                  </div>
                  <div className="tp-service-content">
                    <h4 className="tp-service-title-sm text-yellow-new text-uppercase">
                      <a>Future-Ready</a>
                    </h4>
                    <p>
                      Expansion plans include staking, yield farming, and
                      additional blockchain integrations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
